import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useBillLineItemForm = (onSubmit, values) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: 'Create Bill Line Item',
        isTitleHidden: false,
        fields: [
          {
            title: 'Description',
            name: 'description',
            type: 'text',
            required: true,
          },
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            required: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit: submitHandler, values });
};

export default useBillLineItemForm;
